import { useEffect } from 'react';

const blobsMap = new Map();
const noConsumersSet = new Set();
const MAX_BLOB_ITEMS = 200;

const getOrCreateBlob = (blob) => {
  if (!blob) return null;
  if (!blobsMap.has(blob)) {
    blobsMap.set(blob, { blob, url: URL.createObjectURL(blob), consumers: 0 });
  }
  return blobsMap.get(blob);
};

export const useLoadFileBlobHelper = (blob) => {
  const blobObj = getOrCreateBlob(blob);
  const url = blobObj?.url;

  useEffect(() => {
    if (!blobObj) return () => {};
    noConsumersSet.delete(blobObj);
    blobObj.consumers += 1;

    return () => {
      blobObj.consumers -= 1;
      if (blobObj.consumers < 1) {
        noConsumersSet.add(blobObj);
        if (noConsumersSet.size > MAX_BLOB_ITEMS) {
          const iterator = noConsumersSet.values();
          let item = iterator.next();
          while (!item.done) {
            const { value } = item;
            if (value.consumers < 1) {
              URL.revokeObjectURL(value.url);
              noConsumersSet.delete(value);
              blobsMap.delete(value.blob);
              break;
            }
            item = iterator.next();
          }
        }
      }
    };
  }, [blobObj]);
  return url;
};
